import { DTO } from '../DTO'

export class SmsPost extends DTO implements req.SmsSend {
  sendingTarget: req.SmsSend['sendingTarget']
  studentIdList: req.SmsSend['studentIdList']
  content: req.SmsSend['content']

  constructor(data) {
    super()
    this.sendingTarget = data.sendingTarget
    this.studentIdList = data.studentIdList
    this.content = data.content
  }
}
